import React, { useEffect, useRef } from 'react';
import {
    FormDataConsumer,
    ReferenceInput,
    SelectInput,
    useDataProvider,
} from 'react-admin';
import { useForm } from 'react-final-form';
import useIsAdmin from '../hooks/useIsAdmin';

export default props => {
    const form = useForm();
    const dataProvider = useDataProvider();
    const lastUserIdRef = useRef<string | number | null>(null);
    const isAdmin = useIsAdmin();

    const syncPartnerFromUser = (userId: string | number) => {
        dataProvider
            .getOne('users', { id: userId })
            .then(({ data: user }) => {
                if (user?.partnerId) {
                    form.change('partnerId', user.partnerId);
                }
            })
            .catch(err => console.error('Error fetching user details:', err));
    };

    return (
        <FormDataConsumer>
            {({ formData }) => {
                useEffect(() => {
                    if (!formData.existingCustomer) return;
                    if (!formData.userId) return;

                    if (lastUserIdRef.current !== formData.userId) {
                        lastUserIdRef.current = formData.userId;
                        syncPartnerFromUser(formData.userId);
                    }
                }, [formData.existingCustomer, formData.userId]);

                const isExisting = !!formData.existingCustomer;

                return (
                    <ReferenceInput
                        variant="outlined"
                        label="Partner"
                        source="partnerId"
                        reference="partners"
                        resource="partners"
                        defaultValue={1}
                        fullWidth={true}
                        style={{ width: '256px' }}
                        {...props}
                    >
                        <SelectInput
                            optionText="name"
                            disabled={!isAdmin && isExisting}
                        />
                    </ReferenceInput>
                );
            }}
        </FormDataConsumer>
    );
};
